export const tags = [
  { value: 'js', label: 'JavaScript' },
  { value: 'html-css', label: 'HTML/CSS' },
  { value: 'react', label: 'React' },
  { value: 'node', label: 'Node' },
  { value: 'algorithm', label: '算法' },
  { value: 'engineering', label: '工程化' },
  { value: 'chrome', label: '浏览器' },
  { value: 'ai', label: 'AI' },
  { value: 'penInterview', label: '笔面试题' },
  { value: 'network', label: '网络面试题' },
];